if (!customElements.get('hc-language')) {
  customElements.define('hc-language', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.trigger = this.querySelector('[popovertarget]');
      this.panel = this.querySelector('[popover]');
      if (!this.trigger || !this.panel) return;
      this.panel.addEventListener('beforetoggle', (event) => {
        if (event.newState === 'open') this.position();
      }, { signal });
      this.panel.addEventListener('toggle', () => {
        const open = this.panel.matches(':popover-open');
        this.trigger.setAttribute('aria-expanded', String(open));
        this.openController?.abort();
        if (!open) return;
        this.position();
        this.openController = new AbortController();
        const openSignal = this.openController.signal;
        window.addEventListener('resize', () => this.close(), { signal: openSignal });
        document.addEventListener('scroll', (event) => {
          if (!this.panel.contains(event.target)) this.close();
        }, { capture: true, passive: true, signal: openSignal });
        this.closest('dialog')?.addEventListener('close', () => this.close(), { once: true, signal: openSignal });
      }, { signal });
      this.addEventListener('submit', (event) => {
        if (event.submitter?.getAttribute('aria-current') !== 'true') return;
        event.preventDefault();
        this.close();
        this.trigger.focus({ preventScroll: true });
      }, { signal });
    }
    position() {
      const rect = this.trigger.getBoundingClientRect();
      const width = Math.min(240, document.documentElement.clientWidth - 24);
      this.panel.style.left = `${Math.max(12, Math.min(rect.right - width, document.documentElement.clientWidth - width - 12))}px`;
      this.panel.style.top = `${Math.min(rect.bottom + 9, Math.max(12, window.innerHeight - 184))}px`;
    }
    close() {
      if (this.panel?.matches(':popover-open')) this.panel.hidePopover();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.openController?.abort();
    }
  });
}
